<template>
  <div v-show="inited">
    <h3 class="mb-5"
        data-cy="step-config-modal">
      Configurar paso {{ step.numeroPaso }} de {{ steps.length }}
    </h3>
    <div class="row">
      <div class="col-6">
        <vs-select
          class="w-100"
          autocomplete
          label="Tipo de paso"
          name="stepType"
          v-model="currentStep.aprobacionesTipoPasoId"
          :disabled="readOnly"
          @change="cleanSurrogate()"
          ref="stepType"
        >
          <vs-select-item
            v-for="type in stepTypesAvalaibles"
            :key="type.opcionId"
            :value="type.valor"
            :text="type.descripcion"
          />
        </vs-select>
      </div>
      <div class="col-6" v-if="currentStep.aprobacionesTipoPasoId === stepTypesMap.GROUP">
        <list-groups
          class="w-100"
          autocomplete
          label="Grupo del responsable"
          name="groupInput"
          :isClearable="false"
          :typeList="currentStep.aprobacionesTipoPasoId"
          v-model="currentStep.tipoValorResponsableId"
          @full-group="currentStep.responsable = $event.label"
          :disabled="readOnly"
        />
      </div>
      <div class="col-6" v-if="currentStep.aprobacionesTipoPasoId === stepTypesMap.USER">
        <list-user
          class="w-100"
          autocomplete
          label="Usuario"
          :isClearable="false"
          name="userInput"
          v-model="currentStep.tipoValorResponsableId"
          @full-user="currentStep.responsable = $event.label"
          :disabled="readOnly"
        />
      </div>
      <div class="col-6 mb-5">
        <vs-select
          class="w-100"
          autocomplete
          label="Tipo de rol"
          name="rolType"
          v-model="currentStep.aprobacionesTipoRolId"
          :disabled="readOnly"
        >
          <vs-select-item
            v-for="rol in rolTypesAvalaibles"
            :key="rol.opcionId"
            :value="rol.valor"
            :text="rol.descripcion"
          />
        </vs-select>
      </div>
      <div class="col-12">
        <label>
          Límite (Días) <span v-if="currentStep.demoraMaxHoras > 0">- {{currentStep.demoraMaxHoras}} días</span>
        </label>
        <vs-slider
          v-if="!readOnly"
          class="mt-1"
          v-model="currentStep.demoraMaxHoras"
          :min="0"
          :max="31"
        />
        <small v-if="!readOnly" class="advice">
          Si este paso no es procesado, se notificará después del tiempo límite
        </small>
      </div>
    </div>
    <div
      class="row mt-3"
      v-if="currentStep.aprobacionesTipoPasoId === stepTypesMap.GROUP || flowType === 'P'"
    >
      <div class="col-6" v-if="currentStep.aprobacionesTipoPasoId === stepTypesMap.GROUP">
        <label>Cantidad mínima aprobación</label>
        <b-form-input
          :disabled="readOnly"
          type="number"
          class="w-100"
          v-model.number="currentStep.cantidadMinAprobacion"
        />
      </div>
      <div class="col-6 d-flex align-items-center" v-if="currentStep.aprobacionesTipoPasoId === stepTypesMap.GROUP">
        <label class="mr-2 mb-0">Carga distribuida</label>
        <vs-switch :disabled="readOnly" v-model="currentStep.distributed"/>
      </div>
      <div class="col-6" v-if="flowType === 'P'">
        <vs-select
          class="w-100"
          autocomplete
          label="Tipo de moneda"
          name="stepType"
          v-model="currentStep.desdePrecioMoneda"
          :disabled="readOnly"
        >
          <vs-select-item
            :key="item.id"
            :value="item.id"
            :text="item.nombre"
            v-for="item in currencyOptions"
          />
        </vs-select>
      </div>
      <div class="col-6 mb-5" v-if="flowType === 'P'">
        <label>Precio desde</label>
        <b-form-input
          :disabled="readOnly"
          type='number'
          v-model.number="currentStep.desdePrecio"
        />
      </div>
    </div>
    <div
      v-show="!readOnly"
      class="row"
      v-if="steps.length !== currentStep.numeroPaso && 1 !== currentStep.numeroPaso"
    >
      <div class="col-6 mt-2 mb-3">
        <div class="d-flex align-items-center mt-5">
          <label class="mr-2 mb-0">Disparar proceso </label>
          <vs-switch v-model="trigger"/>
        </div>
      </div>
    </div>
    <div class="row" v-if="trigger">
      <div class="col-12">
        <Consequences
          @consequences="addConsequences"
          :reference="reference"
          :original="currentStep.gatillaciones"
          :readOnly="readOnly"
        />
        <hr>
      </div>
    </div>
    <div class="row mb-5" v-if="currentStep.aprobacionesTipoPasoId === stepTypesMap.USER">
      <div class="col-6">
        <div class="d-flex align-items-center mt-5">
          <label class="mr-2 mb-0">Subrogado </label>
          <vs-switch @change="cleanSurrogate()" :disabled="readOnly" v-model="surrogate"/>
        </div>
      </div>
      <div class="col-6">
        <list-user
          class="w-100"
          autocomplete
          label=" "
          name="surrogate"
          v-model="currentStep.subrogadoId"
          @full-user="currentStep.subrogado = $event.label"
          :disabled="readOnly || !surrogate"
        />
      </div>
      <div class="col-6">
        <label>Desde</label>
        <b-form-datepicker
          v-model="from"
          class="w-100"
          :disabled="readOnly || !surrogate"
          label-no-date-selected="Seleccione la fecha"
          label-help=""
          hide-header
          :min="minDate"
          start-weekday="1"
          dropleft
        ></b-form-datepicker>
      </div>
      <div class="col-6">
        <label>Hasta</label>
        <b-form-datepicker
          v-model="to"
          class="w-100"
          :disabled="readOnly || !surrogate"
          label-no-date-selected="Seleccione la fecha"
          label-help=""
          hide-header
          start-weekday="1"
          dropright
          :min="from"
        ></b-form-datepicker>
      </div>
    </div>
    <div class="row mb-5" v-if="currentStep.aprobacionesTipoRolId === rolTypes.SIGNER">
      <div class="col-6">
        <div class="d-flex align-items-center mt-5">
          <h4>Posición pre definida de la firma</h4>
        </div>
      </div>
      <div class="col-6">
        <label>Página</label>
        <input readonly class="form-control" v-model="currentStep.pagina" type="number">
      </div>
      <div class="col-6 col-md-6">
        <label>Posición X</label>
        <input readonly class="form-control" v-model="currentStep.x" data-cy="x">
      </div>
      <div class="col-6 col-md-6">
        <label>Posición Y</label>
        <input readonly class="form-control" v-model="currentStep.y" data-cy="y">
      </div>
    </div>
    <div class="row" v-if="extraConfig.requeridos">
      <div class="col-12">
        <div class="d-flex align-items-center mt-5">
          <h4>{{ extraConfig.requeridosTitle || 'Configuraciones requeridas' }}</h4>
        </div>
      </div>
      <!-- Recorrer array de campos requeridos -->
      <div class="col-6" v-for="(field, index) in extraConfig.requeridos" :key="index">
        <label
          v-bind:for="'required-'+field.valor"
        >
          {{ field.label }}
        </label>
        <input
          v-bind:name="'required-'+field.valor"
          class="form-control"
          v-model="requeridos[field.valor]"
        >
      </div>
    </div>
    <div class="mt-5 w-100 d-flex justify-content-end">
      <b-button
        variant="warning"
        class="mt-5 mr-5"
        @click="modify"
        v-if="!readOnly"
      >
        Modificar
      </b-button>
      <b-button
        variant="primary"
        class="mt-5 mr-5"
        @click="$emit('close')"
      >
        {{ readOnly ? 'Cerrar' : 'Cancelar' }}
      </b-button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import StepTypes, { CAN_REPEAT_TYPES, SHOULD_UPDATE_LABELS_TYPES } from '@/febos/chile/dnt/mixins/StepTypes';
import RolTypes from '@/febos/chile/dnt/mixins/RolTypes';
import ListGroups from '@/febos/chile/lists/components/ListGroups';
import ListUser from '@/febos/chile/lists/components/ListUser';
import Consequences from '@/febos/chile/approvals/components/templates/Consequences';
import Currency from '@/febos/chile/approvals/mixins/Currency';

export default {
  name: 'ConfigureStepModal',
  components: {
    ListGroups, ListUser, Consequences
  },
  props: [
    'reference',
    'step',
    'steps',
    'readOnly',
    'flowType',
    'modifyStep',
    'file',
    'signatures',
  ],
  data() {
    return {
      stepTypesCodes: StepTypes,
      rolTypesCodes: RolTypes,
      inited: false,
      requeridos: {},
      minDate: this.$moment().format('YYYY-MM-DD'),
      trigger: false,
      surrogate: false,
      stepTypesMap: StepTypes,
      rolTypes: RolTypes,
      currencyOptions: Currency,
      currentStep: JSON.parse(JSON.stringify(this.step))
    };
  },
  computed: {
    ...mapGetters('Approvals', [
      'stepTypes',
      'stepRoles'
    ]),

    stepTypesAvalaibles() {
      return this.stepTypes.filter((item) => item.plantilla);
    },
    rolTypesAvalaibles() {
      const stepType = this.actualStepType;
      if (stepType && stepType.tipoRol && stepType.tipoRol.length > 0) {
        const avalaiblesTipesId = stepType.tipoRol;
        if (stepType.valor === this.stepTypesCodes.OFFICE) {
          return this.stepRoles
            .filter((item) => avalaiblesTipesId.includes(item.valor))
            .map((rol) => {
              if (rol.valor === this.rolTypesCodes.SIGNER) {
                return {
                  ...rol,
                  descripcion: 'Numerar/Tramitar'
                };
              }
              return rol;
            });
        }
        console.log('steproles', this.stepRoles);
        return this.stepRoles.filter((item) => avalaiblesTipesId.includes(item.valor));
      }
      console.log('steproles', this.stepRoles);
      return this.stepRoles;
    },
    to: {
      get() {
        return this.currentStep.subrogadoHasta;
      },
      set(date) {
        this.currentStep.subrogadoHasta = this.$moment(date).format('YYYY-MM-DD HH:mm:ss');
      }
    },
    from: {
      get() {
        return this.currentStep.subrogadoDesde;
      },
      set(date) {
        this.currentStep.subrogadoDesde = this.$moment(date).format('YYYY-MM-DD HH:mm:ss');
      }
    },
    actualStepType() {
      const tipes = this.stepTypesAvalaibles;
      const stepType = tipes.find((item) => item.valor === this.currentStep.aprobacionesTipoPasoId);
      return stepType;
    },
    extraConfig() {
      let { extra } = this.actualStepType;
      // si es string pasar a json
      if (typeof extra === 'string') {
        extra = JSON.parse(extra);
      }
      return extra;
    }
  },
  methods: {
    cleanSurrogate() {
      if (!this.surrogate) {
        this.currentStep.subrogadoDesde = '';
        this.currentStep.subrogadoHasta = '';
        this.currentStep.subrogadoId = '';
        this.currentStep.subrogado = '';
      }
    },
    notify(message) {
      this.$vs.notify({
        title: 'Oops!',
        text: message,
        color: 'danger',
        time: 6000,
        position: 'top-center'
      });
    },
    modify() {
      console.group('Modifying Step', this.currentStep);
      try {
        const stepNumber = this.currentStep.numeroPaso;
        let responsible = this.currentStep.tipoValorResponsableId;
        const shouldUpdateLabel = SHOULD_UPDATE_LABELS_TYPES.includes(
          this.currentStep.aprobacionesTipoPasoId
        );
        if (shouldUpdateLabel) {
          responsible = this.currentStep.aprobacionesTipoPasoId;
          this.currentStep.responsable = this.$refs.stepType.valuex;
        }
        const step = this.currentStep.aprobacionesTipoPasoId;
        const isRepeable = CAN_REPEAT_TYPES.includes(step);
        const role = this.currentStep.aprobacionesTipoRolId;
        this.currentStep.stepId = `${stepNumber}${responsible}&${step}${role}`;
        if (isRepeable) {
          this.currentStep.id = `${stepNumber}${responsible}&${step}${role}`;
        } else {
          this.currentStep.id = `${responsible}&${step}${role}`;
        }
        if (this.requeridos && Object.keys(this.requeridos).length > 0) {
          let actualConfig = this.currentStep.configuration || {};
          console.log('Existing configuration before update:', actualConfig);
          if (typeof actualConfig === 'string') {
            try {
              actualConfig = JSON.parse(actualConfig);
            } catch (e) {
              console.error('Error parsing existing configuration:', e);
              actualConfig = {};
            }
          }
          actualConfig.requeridos = this.requeridos;
          this.currentStep.configuration = actualConfig;
          console.log('Updated configuration:', this.currentStep.configuration);
        }
        if (!this.trigger) {
          this.currentStep.gatillaciones = [];
        }

        if (this.currentStep.subrogado?.length
          && (!this.currentStep.subrogadoDesde?.length
            || !this.currentStep.subrogadoHasta?.length)
        ) {
          this.notify('No se puede agregar un subrogado sin ambas fechas.');
          return;
        }

        if (this.currentStep.subrogadoId === this.currentStep.tipoValorResponsableId) {
          this.notify('El responsable y el subrogado no pueden ser los mismos.');
          return;
        }

        const previousStep = this.steps[this.currentStep.index - 1];
        const nextStep = this.steps[this.currentStep.index + 1];
        const canRepeat = previousStep
          ? CAN_REPEAT_TYPES.includes(previousStep.aprobacionesTipoPasoId)
          : false;
        // Compara el objeto modificado con el obj anterior existente en this.steps
        if ((previousStep && !canRepeat)
          && this.steps[this.currentStep.index - 1]
          && this.steps[this.currentStep.index - 1].id === this.currentStep.id
        ) {
          this.notify('No pueden haber dos pasos iguales de forma continua.');
          return;
        }

        const canNextRepeat = nextStep
          ? CAN_REPEAT_TYPES.includes(nextStep.aprobacionesTipoPasoId)
          : false;
        if ((nextStep && !canNextRepeat)
          && this.steps[this.currentStep.index + 1]
          && this.steps[this.currentStep.index + 1].id === this.currentStep.id
        ) {
          this.notify('No pueden haber dos pasos iguales de forma continua.');
          return;
        }
        console.log('Modifying step with data:', this.currentStep, this.step);
        this.modifyStep(this.step, this.currentStep);
      } finally {
        console.groupEnd();
      }
    },
    addConsequences(consequences) {
      this.currentStep.gatillaciones = consequences;
    },
    init() {
      try {
        this.inited = false;
        this.requeridos = {};
        this.trigger = this.currentStep.gatillaciones.length > 0;
        this.surrogate = this.currentStep.subrogado.length;
        console.group('Init Configure Step Modal', this.currentStep);
        if (this.currentStep.configuration) {
          if (typeof this.currentStep.configuration === 'string') {
            try {
              this.currentStep.configuration = JSON.parse(this.currentStep.configuration);
            } catch (e) {
              console.error('Error parsing step configuration:', e);
              this.currentStep.configuration = {};
            }
          } else {
            this.currentStep.configuration = JSON.parse(
              JSON.stringify(this.currentStep.configuration)
            );
          }
          this.requeridos = this.currentStep.configuration?.requeridos || {};
          console.log('Requeridos loaded:', this.requeridos, this.currentStep.configuration, typeof this.currentStep.configuration);
        }
        console.log('Extra Config:', this.extraConfig);
        if (this.extraConfig?.requeridos) {
          const requiredConfigs = this.extraConfig.requeridos;
          requiredConfigs.forEach((requiredConfig) => {
            if (requiredConfig.default && !this.requeridos[requiredConfig.valor]) {
              console.log(
                `Setting default for ${requiredConfig.valor}:`,
                requiredConfig.default
              );
              this.requeridos[requiredConfig.valor] = requiredConfig.default;
            }
          });
        }
        console.groupEnd();
      } finally {
        this.inited = true;
      }
    },
  },
  mounted() {
    try {
      this.inited = false;
      this.init();
    } finally {
      this.inited = true;
    }
  }
};
</script>

<style scoped>
.advice {
  font-size: 10px;
}
.vs-circle-slider vs-circles-slider vs-slider--circles vs-slider--circle {
  background: darkorange;
}
</style>
